import { render, staticRenderFns } from "./PrintingCutting.vue?vue&type=template&id=00b03ee2&scoped=true"
import script from "./PrintingCutting.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintingCutting.vue?vue&type=script&setup=true&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=00b03ee2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b03ee2",
  null
  
)

export default component.exports